import React, { useState, useEffect } from 'react'
import { MainContext, useContext } from '../../../Main/MainContext'
import Layout from '../../../Components/Layout'
import { useTranslation } from 'react-i18next'

import { Link, useNavigate, useNavigation, useParams } from 'react-router-dom'

import Modal from 'react-modal';

import { api, server, prefix, endpoints } from '../../../Main/Api';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import moment from 'moment/moment'
import axios from 'axios'
const MySwal = withReactContent(Swal)

export default function TedaviGoruntule() {

  const { user, token } = useContext(MainContext)
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const [ayarlar, setAyarlar] = useState(null)
  const [tedavi, setTedavi] = useState()
  const [hasta, setHasta] = useState()
  const [takvim, setTakvim] = useState()


  const [maModal, setMaModal] = useState(false)
  const [maAksiyon, setMaAksiyon] = useState("")
  const [maTarih, setMaTarih] = useState(null)

  const [maEditModal, setMaEditModal] = useState(false)
  const [maEditAksiyon, setMaEditAksiyon] = useState("")
  const [maEditTarih, setEditMaTarih] = useState(null)
  const [maEditUuid, setEditMaUuid] = useState("")

  const [tarih, setTarih] = useState()
  const [aksiyon, setAksiyon] = useState()

  const [aksiyonEkleniyor, setAEkleniyor] = useState(false)

  const { id } = useParams()

  useEffect(() => {
    tedavi_bilgileri()
  }, [])

  useEffect(() => {
    Modal.setAppElement('#root');
  }, [])

  const tedavi_bilgileri = () => {
    setLoading(true)
    let url = server + prefix + endpoints.tedavi_bilgileri.replace(":id", id);
    api.request(url, "GET", null, {
      "Authorization": "Bearer " + token
    }).then((response) => {
      const { data } = response;

      setAyarlar(data.ayarlar)
      setTedavi(data.tedavi)
      setHasta(data.hasta)

      console.log(data.takvim)

      // setTakvim(data.takvim)
      const order = ["TEDAVI", "ANKET", "URINER"];
      setTakvim(
        [...data.takvim]
          .map(item => ({
            ...item,
            uuid: crypto.randomUUID()
          }))
          .sort((a, b) => {
            const dateA = moment(a.planlanan_tarih, "DD.MM.YYYY");
            const dateB = moment(b.planlanan_tarih, "DD.MM.YYYY");

            if (dateA.isBefore(dateB)) return -1;
            if (dateA.isAfter(dateB)) return 1;

            return order.indexOf(a.aksiyon) - order.indexOf(b.aksiyon);
          })
      );


      setLoading(false)
    }).catch((err) => {
      setLoading(false)
    })
  }

  const btnManuelAksiyon = () => {
    if (takvim.length < 1) {
      MySwal.fire({
        title: "Önce otomatik takvim oluşturulmalıdır.",
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    setMaModal(true)
  }

  const btnManuelAksiyonDuzenle = (item) => {
    setMaEditAksiyon(item.aksiyon)
    setEditMaTarih(moment(item.planlanan_tarih, "DD.MM.YYYY").format("YYYY-MM-DD"))
    setEditMaUuid(item.uuid)
    setMaEditModal(true)
  }

  const manuelAksiyonEkle = () => {
    if (takvim.length < 1) return;

    if (maAksiyon == "") {
      MySwal.fire({
        title: "Aksiyon seçilmedi!",
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    if (maTarih == null) {
      MySwal.fire({
        title: "Aksiyon tarihi seçilmedi!",
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    const tmpAksiyon = maAksiyon;
    const tmpTarih = moment(maTarih).format("DD.MM.YYYY")

    // Bir güne aynı aksiyondan birden fazla eklenemez
    if (takvim.filter(x => x.planlanan_tarih == tmpTarih && x.aksiyon == tmpAksiyon).length > 0) {
      MySwal.fire({
        title: `<span style="font-size:18px">
                  ${tmpTarih} tarihinde zaten bir ${t(tmpAksiyon)} aksiyonu var!
                  </span>`,
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    const baslangicTarihi = moment(takvim[0].planlanan_tarih, "DD.MM.YYYY");
    const bitisTarihi = moment(takvim[takvim.length - 1].planlanan_tarih, "DD.MM.YYYY");
    const at = moment(tmpTarih, "DD.MM.YYYY");

    if (at.isBefore(baslangicTarihi, 'day')) {
      MySwal.fire({
        title: `<span style="font-size:18px">
                  Başlangıç tarihinden önce bir aksiyon ekleyemezsiniz.
                  </span>`,
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    if (at.isAfter(bitisTarihi, 'day') && tmpAksiyon != "ANKET") {
      MySwal.fire({
        title: `<span style="font-size:18px">
                  Bitiş tarihinden sonra anket haricinden başka bir aksiyon eklenemez!
                  </span>`,
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    setTakvim((prev) => [...prev, { aksiyon: tmpAksiyon, planlanan_tarih: tmpTarih, label: t(tmpAksiyon.toLowerCase()) }])

    setTimeout(() => {
      const order = ["TEDAVI", "ANKET", "URINER"];

      setTakvim(prevTakvim =>
        [...prevTakvim].sort((a, b) => {
          const dateA = moment(a.planlanan_tarih, "DD.MM.YYYY");
          const dateB = moment(b.planlanan_tarih, "DD.MM.YYYY");

          if (dateA.isBefore(dateB)) return -1;
          if (dateA.isAfter(dateB)) return 1;

          return order.indexOf(a.aksiyon) - order.indexOf(b.aksiyon);
        })
      );
    }, 100)
  }

  const manuelAksiyonDuzenle = () => {
    if (takvim.length < 1) return;

    if (maEditTarih == null) {
      MySwal.fire({
        title: "Aksiyon tarihi seçilmedi!",
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    const tmpAksiyon = maEditAksiyon;
    const tmpTarih = moment(maEditTarih).format("DD.MM.YYYY")

    // Bir güne aynı aksiyondan birden fazla eklenemez
    if (takvim.filter(x => x.planlanan_tarih == tmpTarih && x.aksiyon == tmpAksiyon).length > 0) {
      MySwal.fire({
        title: `<span style="font-size:18px">
                  ${tmpTarih} tarihinde zaten bir ${t(tmpAksiyon)} aksiyonu var!
                  </span>`,
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    const baslangicTarihi = moment(takvim[0].planlanan_tarih, "DD.MM.YYYY");
    const bitisTarihi = moment(takvim[takvim.length - 1].planlanan_tarih, "DD.MM.YYYY");
    const at = moment(tmpTarih, "DD.MM.YYYY");

    if (at.isBefore(baslangicTarihi, 'day')) {
      MySwal.fire({
        title: `<span style="font-size:18px">
                  Başlangıç tarihinden önce bir aksiyon ekleyemezsiniz.
                  </span>`,
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    if (at.isAfter(bitisTarihi, 'day') && tmpAksiyon != "ANKET") {
      MySwal.fire({
        title: `<span style="font-size:18px">
                  Bitiş tarihinden sonra anket haricinden başka bir aksiyon eklenemez!
                  </span>`,
        icon: "error",
        confirmButtonText: t('tamam'),
      })
      return;
    }

    setTakvim(prevList =>
      prevList.map(item =>
        item.uuid === maEditUuid
          ? { ...item, ...{ planlanan_tarih: tmpTarih } }
          : item
      )
    );

    const order = ["TEDAVI", "ANKET", "URINER"];

    setTakvim(prevTakvim =>
      [...prevTakvim].sort((a, b) => {
        const dateA = moment(a.planlanan_tarih, "DD.MM.YYYY");
        const dateB = moment(b.planlanan_tarih, "DD.MM.YYYY");

        if (dateA.isBefore(dateB)) return -1;
        if (dateA.isAfter(dateB)) return 1;

        return order.indexOf(a.aksiyon) - order.indexOf(b.aksiyon);
      })
    );

    setMaEditModal(false)
  }

  const aksiyonSil = (item) => {
    const tmpTakvim = takvim.filter(x => x.uuid != item.uuid);
    setTakvim(tmpTakvim)
  }

  const takvimiKaydet = () => {
    MySwal.fire({
      title: "Takvimi kaydetmek istediğinizden emin misiniz?",
      icon: "question",
      confirmButtonText: "Kaydet",
      showCancelButton: true,
      cancelButtonText: "Vazgeç"
    }).then((x) => {
      if (x.isConfirmed) {

        let url = server + prefix + endpoints.tedavi_takvimi_kaydet.replace(":id", tedavi.id);
        api.request(url, "PUT", {
          takvim: takvim.filter(x => !x.tamamlandi)
        }, {
          "Authorization": "Bearer " + token
        }).then((response) => {
          const { data } = response;
          const { hata, mesaj } = data

          MySwal.fire({
            title: mesaj,
            icon: hata ? "error" : "success",
            confirmButtonText: t('tamam'),
          })
        })

      }
    })
  }

  return (
    <Layout baslik={t('tedavi_goruntule')}>

      <Modal
        isOpen={maEditModal}
        onRequestClose={() => setMaEditModal(false)}
        style={maModalStyle}>

        <h3>Manuel Aksiyon Düzenleme Ekranı</h3>
        <hr />

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="manuelEditAksiyon">Aksiyon</label>
              <select value={maEditAksiyon} id="manuelEditAksiyon" className="form-control" disabled>
                <option value="TEDAVI">Tedavi</option>
                <option value="ANKET">Anket</option>
                <option value="URINER">Üriner</option>
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="manuelEditAksiyonTarihi">Tarih</label>
              <input value={maEditTarih} onChange={(e) => setEditMaTarih(e.target.value)} id="manuelEditAksiyonTarihi" type="date" className="form-control" />
            </div>
          </div>
        </div>

        <button onClick={manuelAksiyonDuzenle} className="btn btn-outline-dark btn-block">
          <i className="fas fa-check"></i> Aksiyonu Güncelle
        </button>

      </Modal>

      <Modal
        isOpen={maModal}
        onRequestClose={() => setMaModal(false)}
        style={maModalStyle}>

        <h3>Manuel Aksiyon Ekleme Ekranı</h3>
        <hr />

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="manuelAksiyon">Aksiyon</label>
              <select value={maAksiyon} onChange={(e) => setMaAksiyon(e.target.value)} id="manuelAksiyon" className="form-control">
                <option value="">Seçilmedi</option>
                <option value="TEDAVI">Tedavi</option>
                <option value="ANKET">Anket</option>
                <option value="URINER">Üriner</option>
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="manuelAksiyonTarihi">Tarih</label>
              <input value={maTarih} onChange={(e) => setMaTarih(e.target.value)} id="manuelAksiyonTarihi" type="date" className="form-control" />
            </div>
          </div>
        </div>

        <button onClick={manuelAksiyonEkle} className="btn btn-outline-dark btn-block">
          <i className="fas fa-check"></i> Aksiyonu Ekle
        </button>

      </Modal>

      {
        (loading || ayarlar == null || tedavi == null || hasta == null || takvim == null) ?
          <>
            <div className="text-center mt-5">
              <i className="fas fa-spinner fa-spin fa-2x mb-2"></i>
              <p>{t("yukleniyor...")}</p>
            </div>
          </>
          :
          <>
            <div className="row">

              <div className="col-md-12 col-12">
                <div className="card shadow">
                  <div className="card-body">

                    <div className="row">

                      <div className="col-md-6">
                        <h4 className='mb-3 text-danger'>{t('hasta_bilgileri')}</h4>

                        <div className="form-group">
                          <label>{t('hasta_adi')}</label>
                          <input type="text" className="form-control" value={hasta.ad + " " + hasta.soyad} disabled />
                        </div>

                        <div className="form-group">
                          <label>{t('yetkili')}</label>
                          <input type="text" className="form-control" value={hasta.yetkili_adi} disabled />
                        </div>

                        <div className="form-group">
                          <label>{t('dogum_tarihi')}</label>
                          <input type="text" className="form-control" value={hasta.dogum_tarihi} disabled />
                        </div>

                        <div className="form-group">
                          <label>{t('cinsiyet')}</label>
                          <input type="text" className="form-control" value={t(hasta.cinsiyet)} disabled />
                        </div>

                        <div className="form-group">
                          <label>{t('ozet_bilgiler')}</label>
                          <textarea className="form-control" rows={6} value={t(hasta.ozet_bilgiler)} disabled></textarea>
                        </div>
                      </div>

                      <div className="col-md-6">

                        <h4 className='mb-3 text-danger'>{t('ref_tp_bilgileri').toUpperCase()}</h4>

                        <div>
                          <div className="form-group">
                            <label htmlFor="recete_adi">{t('tp_adi')}</label>
                            <input id="recete_adi" value={tedavi.referans_recete_adi} type="text" className="form-control" disabled />
                          </div>

                          <div className="form-group">
                            <label htmlFor="ayak">{t('ayak')}</label>
                            <select defaultValue={tedavi.uygulanacak_ayak} id="ayak" className="form-control" disabled>
                              <option value="">{t('secim_yapilmadi')}</option>
                              <option value="SOL">{t('SOL')}</option>
                              <option value="SAG">{t('SAG')}</option>
                              <option value="CIFT">{t('CIFT')}</option>
                            </select>
                          </div>

                          <div className="form-group">
                            <div style={{ display: 'flex' }}>
                              <label htmlFor="hafta_sayisi" style={{ flex: 1 }}>{t('hafta_sayisi')}</label>
                              <label htmlFor="hafta_sayisi">{tedavi.hafta_sayisi}</label>
                            </div>
                            <input id="hafta_sayisi" type="range" className="custom-range" value={tedavi.hafta_sayisi} min={ayarlar.en_az_hafta_sayisi} max={ayarlar.en_fazla_hafta_sayisi} step="1" />
                          </div>

                          <div className="form-group">
                            <div style={{ display: 'flex' }}>
                              <label htmlFor="haftadaki_siklik" style={{ flex: 1 }}>{t('haftadaki_siklik')}</label>
                              <label htmlFor="haftadaki_siklik">{tedavi.siklik}</label>
                            </div>
                            <input id="haftadaki_siklik" type="range" className="custom-range" value={tedavi.siklik} min={ayarlar.en_az_haftadaki_siklik} max={ayarlar.en_fazla_haftadaki_siklik} step="1" />
                          </div>

                          <div className="form-group">
                            <div style={{ display: 'flex' }}>
                              <label htmlFor="tedavi_suresi" style={{ flex: 1 }}>{t('tedavi_suresi_dk')}</label>
                              <label htmlFor="tedavi_suresi">{tedavi.tedavi_suresi}</label>
                            </div>
                            <input id="tedavi_suresi" type="range" className="custom-range" value={tedavi.tedavi_suresi} min={ayarlar.en_az_tedavi_suresi} max={ayarlar.en_fazla_tedavi_suresi} step="1" />
                          </div>

                          <div className="form-group">
                            <div style={{ display: 'flex' }}>
                              <label htmlFor="frekans" style={{ flex: 1 }}>{t('frekans_hz')}</label>
                              <label htmlFor="frekans">{tedavi.frekans}</label>
                            </div>
                            <input id="frekans" type="range" className="custom-range" value={tedavi.frekans} min={ayarlar.en_az_frekans} max={ayarlar.en_fazla_frekans} step="1" />
                          </div>

                          <div className="form-group">
                            <div style={{ display: 'flex' }}>
                              <label htmlFor="darbe_genisligi" style={{ flex: 1 }}>{t('dbg_mikro_sn')}</label>
                              <label htmlFor="darbe_genisligi">{tedavi.darbe_genisligi}</label>
                            </div>
                            <input id="darbe_genisligi" type="range" className="custom-range" value={tedavi.darbe_genisligi} min={ayarlar.en_az_darbe_genisligi} max={ayarlar.en_fazla_darbe_genisligi} step={20} />
                          </div>

                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-md-12 col-12 mt-3">
                <div className="card shadow">
                  <div className="card-body">
                    <div className="table-responsive mb-3">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th className='text-center'>{t("tedavi_durumu2")}</th>
                            <th className='text-center'>{t("tedavi_surdurme_basarisi")}</th>
                            <th className='text-center'>{t("toplam_gecikme")}</th>
                            <th className='text-center'>{t("tedavi_basarisi")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className='text-center'>{t(tedavi.durum).toUpperCase()}</td>
                            <td className='text-center'>{t(tedavi.str_tedavi_surdurme_basarisi).toUpperCase()}</td>
                            <td className='text-center'>{tedavi.toplam_gecikme + " " + t('gun')}</td>
                            <td className='text-center'>{t(tedavi.basari).toUpperCase()}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <h4 className="text-danger mb-3">{t('tedavi_takvimi')}</h4>

                    <button onClick={btnManuelAksiyon} className="btn btn-outline-dark mb-3">
                      <i className="fas fa-plus"></i> {t('manuel_aksiyon_ekle')}
                    </button>

                    <div className="table-responsive">
                      <table className="table table-striped table-sm">
                        <thead>
                          <tr>
                            <th className='text-center'>#</th>
                            <th className='text-center'></th>
                            <th className='text-center'>{t('planlanan_tarih')}</th>
                            <th className='text-center'>{t('aksiyon')}</th>
                            <th className='text-center'>{t('tamamlandi')}</th>
                            <th className='text-center'>{t('anket_basarisi')}</th>
                            <th className='text-center'>{t('tedavi_surdurme_basarisi2')}</th>
                            <th className='text-center'>{t('anket_skoru')}</th>
                            <th className='text-center'>{t('anket_skoru') + " 2"}</th>
                            <th className='text-center'>{t('baslangic_tarihi')}</th>
                            <th className='text-center'>{t('bitis_tarihi')}</th>
                            <th className='text-center'>{t('uygulanma_tarihi')}</th>
                            <th className='text-center'>{t('hata_kodu')}</th>
                            <th className='text-center'>{t('tedavi_frekansi_hz')}</th>
                            <th className='text-center'>{t('tedavi_dbg_us')}</th>
                            <th className='text-center'>{t('ayarlanan_tedavi_akimi_ma')}</th>
                            <th className='text-center'>{t('olculen_tedavi_akimi_ma')}</th>
                            <th className='text-center'>{t('ortalama_ted_gerilimi_peak_v')}</th>
                            <th className='text-center'>{t('ortalama_tedavi_empedansi')}</th>
                            <th className='text-center'>{t('hareketlilik_katsayisi')}</th>
                            <th className='text-center'>{t('tedavi_sonrasi_pil_gerilimi')}</th>
                            <th className='text-center'>{t('su_cihaz_id')}</th>
                            <th className='text-center'>{t('su_fw_versiyon')}</th>
                            <th className='text-center'>{t('su_mobil_app_versiyon')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            takvim.map((item, index) => {
                              return (
                                <tr>
                                  <td className='text-center'>{index + 1}</td>
                                  <td>
                                    {
                                      (!item.tamamlandi) &&
                                      <>
                                        <button onClick={() => btnManuelAksiyonDuzenle(item)} title="Düzenle" className="btn btn-outline-info btn-sm">
                                          <i className="fas fa-edit"></i>
                                        </button>
                                        <button onClick={() => aksiyonSil(item)} title="Sil" className="btn btn-outline-danger btn-sm ml-2">
                                          <i className="fas fa-trash-alt"></i>
                                        </button>
                                      </>
                                    }
                                  </td>
                                  <td className='text-center'>{item.planlanan_tarih}</td>
                                  <td className='text-center'>
                                    {
                                      (item.aksiyon == "TEDAVI") &&
                                      <>
                                        <span className="badge badge-success">{t(item.aksiyon)}</span>
                                      </>
                                    }
                                    {
                                      (item.aksiyon == "URINER") &&
                                      <>
                                        <Link to={"/uriner/goruntule/" + item.id}>
                                          <span className="badge badge-danger">{t(item.aksiyon)}</span>
                                        </Link>
                                      </>
                                    }
                                    {
                                      (item.aksiyon == "ANKET") &&
                                      <>
                                        <Link to={"/anket/goruntule/" + item.id}>
                                          <span className="badge badge-info">{t(item.aksiyon)}</span>
                                        </Link>
                                      </>
                                    }
                                  </td>
                                  <td className='text-center'>
                                    {
                                      item.tamamlandi ?
                                        <>
                                          <i className="fas fa-check text-success"></i>
                                        </>
                                        :
                                        <>
                                          <i className="fas fa-times text-danger"></i>
                                        </>
                                    }
                                  </td>
                                  <td className='text-center'>
                                    {
                                      item.aksiyon == "ANKET" ? t(item.tedavi_basarisi) : ''
                                    }
                                  </td>
                                  <td className='text-center'>{item.str_tedavi_surdurme_basarisi}</td>
                                  <td className='text-center'>{(item.data != null && item.data.length >= 1) ? item.data[0].skor.toFixed(2) : ""}</td>
                                  <td className='text-center'>{(item.data != null && item.data.length >= 2) ? item.data[1].skor.toFixed(2) : ""}</td>
                                  <td className='text-center'>{item.data != null ? item.data.baslangic_tarihi : ""}</td>
                                  <td className='text-center'>{item.data != null ? item.data.bitis_tarihi : ""}</td>
                                  <td className='text-center'>{item.aksiyon == "TEDAVI" ? "" : item.uygulanma_tarihi}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.hata_kodu : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.frekans : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.darbe_genisligi : ""}</td>

                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.ayarlanan_akim : ""}</td>

                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.akim : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.ortalama_gerilim : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.e_direnc_ort : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.hareketlilik_katsayisi : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.ts_pil_gerilimi : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.cihaz_seri_no : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.firmware_version : ""}</td>
                                  <td className='text-center'>{(item.aksiyon == "TEDAVI" && item.data != null) ? item.data.mobil_version : ""}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>

                    <button onClick={takvimiKaydet} className="btn btn-outline-dark">
                      <i className="fas fa-check"></i> Takvimi Kaydet
                    </button>

                  </div>
                </div>
              </div>

            </div>
          </>
      }

    </Layout>
  )
}

const maModalStyle = {
  content: {
    minWidth: '35%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};